"use client";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import { getImageUrl } from "../../lib/util";

const IndustryDemandSection = ({ project_trends, trends }) => {
  const [activeTab, setActiveTab] = useState(trends?.[0]?.title || "");
  const current = trends?.find((t) => t.title === activeTab);

  if (!trends || trends.length === 0) return null;

  return (
    <section id="IndustryDemand" className="py-4 my-4 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4">
        <h1 className="flex justify-center text-[26px] items-center text-center  font-bold text-gray-500">
          {project_trends?.heading}
        </h1>
        <h4 className="flex justify-center items-center text-center  font-bold text-black-400">
          {project_trends?.sub_heading}
        </h4>

        <div className="bg-white p-8 shadow-lg rounded-xl">
          {/* Tabs */}
          <div className="flex items-center gap-4 mb-10 flex-wrap">
            {trends.map((trend) => (
              <button
                key={trend.id}
                onClick={() => setActiveTab(trend.title)}
                className={`px-4 h-10 rounded-lg font-semibold ${
                  activeTab === trend.title
                    ? "bg-blue-100 text-blue-900"
                    : "text-gray-800 hover:text-blue-600"
                }`}
              >
                {trend.title}
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="grid md:grid-cols-3 grid-cols-1 gap-10">
            {/* Salary */}
            <div className="flex flex-col items-start gap-4">
              <div className="text-xs font-semibold text-gray-800">
                Annual Salary
              </div>
         <div className="w-full max-w-xs">
          <div className="flex justify-between items-end h-32 gap-2">
            {/* Min Salary */}
            <div className="flex flex-col items-center gap-1">
              <span className="text-xs font-semibold text-gray-800">
                {current?.min_salary}
              </span>
              <div className="w-full h-5 bg-yellow-400 bg-opacity-60 rounded-sm"></div>
            </div>

            {/* Spacer */}
            <div className="w-full h-9 bg-yellow-400 bg-opacity-40 rounded-sm"></div>

            {/* Avg Salary */}
            <div className="flex flex-col items-center gap-1">
              <span className="text-xs font-semibold text-gray-800">
                {current?.avg_salary}
              </span>
              <div className="w-full h-16 bg-yellow-400 bg-opacity-80 rounded-sm"></div>
            </div>

            {/* Spacer */}
            <div className="w-full h-8 bg-yellow-400 bg-opacity-40 rounded-sm"></div>

            {/* Max Salary */}
            <div className="flex flex-col items-center gap-1">
              <span className="text-xs font-semibold text-gray-800">
                {current?.max_salary}
              </span>
              <div className="w-full h-4 bg-yellow-400 bg-opacity-100 rounded-sm"></div>
            </div>
          </div>

          <div className="flex justify-between mt-2 text-xs text-gray-700 opacity-70">
            <span>Min</span>
            <span>Average</span>
            <span>Max</span>
          </div>
        </div>


            </div>

{/* Hiring Companies */}
<div>
  <p className="text-sm font-semibold text-gray-800 mb-4">
    Hiring Companies
  </p>
  <div className="grid grid-cols-2 gap-4">
    {current?.hirings?.map((hiring, index) => {
      const logoAttributes = hiring?.logo?.data?.[0]?.attributes;
      const logoUrl = logoAttributes ? getImageUrl(logoAttributes) : null;

      return (
        <div
          key={index}
          className="px-3 py-2 bg-gray-100 rounded flex items-center justify-center h-12"
        >
          {logoUrl ? (
            <Image
              src={logoUrl}
              alt={hiring.title || "Company logo"}
              width={96}
              height={24}
              className="max-h-6 object-contain"
              unoptimized
            />
          ) : (
            <span className="text-sm text-gray-700">{hiring.title}</span>
          )}
        </div>
      );
    })}
  </div>
</div>

            {/* Demand */}
            <div>
              <p className="text-sm font-semibold text-gray-800 mb-4">
                Demand
              </p>
              <div className="flex items-start gap-3">
                <span className="text-3xl">📈</span>
                <div>
                  <div className="text-lg font-bold text-black">
                    {current?.demand_level}
                  </div>
                  <div className="text-sm text-gray-700">
                    {current?.demand_note}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryDemandSection;
